var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFunctions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666016,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#D8E6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.25 7C21.25 6.58579 21.5858 6.25 22 6.25H26C26.4142 6.25 26.75 6.58579 26.75 7V11C26.75 11.4142 26.4142 11.75 26 11.75C25.5858 11.75 25.25 11.4142 25.25 11V7.75H22C21.5858 7.75 21.25 7.41421 21.25 7Z",
    fill: "#1570EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5303 6.46967C26.8232 6.76256 26.8232 7.23744 26.5303 7.53033L20.5303 13.5303C20.2374 13.8232 19.7626 13.8232 19.4697 13.5303C19.1768 13.2374 19.1768 12.7626 19.4697 12.4697L25.4697 6.46967C25.7626 6.17678 26.2374 6.17678 26.5303 6.46967Z",
    fill: "#1570EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 20.25C8.41421 20.25 8.75 20.5858 8.75 21V24.25H12C12.4142 24.25 12.75 24.5858 12.75 25C12.75 25.4142 12.4142 25.75 12 25.75H8C7.58579 25.75 7.25 25.4142 7.25 25V21C7.25 20.5858 7.58579 20.25 8 20.25Z",
    fill: "#1570EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5303 18.4697C14.8232 18.7626 14.8232 19.2374 14.5303 19.5303L8.53033 25.5303C8.23744 25.8232 7.76256 25.8232 7.46967 25.5303C7.17678 25.2374 7.17678 24.7626 7.46967 24.4697L13.4697 18.4697C13.7626 18.1768 14.2374 18.1768 14.5303 18.4697Z",
    fill: "#1570EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 16C6.25 10.0658 11.0658 5.25 17 5.25C17.7404 5.25 18.4696 5.32508 19.1671 5.46458C19.5733 5.54581 19.8367 5.94093 19.7555 6.3471C19.6742 6.75327 19.2791 7.01668 18.8729 6.93545C18.2704 6.81494 17.6396 6.75 17 6.75C11.8942 6.75 7.75 10.8942 7.75 16C7.75 16.6393 7.81487 17.2593 7.935 17.8507C8.01746 18.2566 7.75523 18.6525 7.34931 18.735C6.94338 18.8174 6.54748 18.5552 6.46502 18.1493C6.32516 17.4607 6.25 16.7407 6.25 16Z",
    fill: "#1570EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6535 13.2646C27.0597 13.1834 27.4548 13.4468 27.5361 13.8529C27.6753 14.5493 27.7506 15.2686 27.7506 16C27.7506 21.9342 22.9348 26.75 17.0006 26.75C16.2603 26.75 15.531 26.6749 14.8335 26.5354C14.4274 26.4542 14.1639 26.0591 14.2452 25.6529C14.3264 25.2468 14.7215 24.9833 15.1277 25.0646C15.7302 25.1851 16.361 25.25 17.0006 25.25C22.1064 25.25 26.2506 21.1058 26.2506 16C26.2506 15.3715 26.1859 14.7508 26.0652 14.1471C25.984 13.7409 26.2474 13.3458 26.6535 13.2646Z",
    fill: "#1570EF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctions);
export default __webpack_public_path__ + "static/media/functions.75e49bea2f26d99df8027a73a6ea6ed3.svg";
export { ForwardRef as ReactComponent };